import SideMenu from "./sideMenu";

const PurchaseOrder = (props) => {
  return (
    <>
      <SideMenu on="purchaseOrder" />
    </>
  );
};

export default PurchaseOrder;
